import { useMutation } from '@tanstack/react-query';
import { createStripeSubscriptionManagementUrl } from 'shared/services/backend-api';

export const useCreateStripeSubscriptionManagementUrlMutation = () =>
  useMutation({
    mutationFn: (stripeCustomerId: string) =>
      createStripeSubscriptionManagementUrl(stripeCustomerId),
  });
